module.exports = __webpack_public_path__ + "img/female.2efe88e4.png";